import {
  SET_ADD_ELEMENTS_PENDING,
  SET_ADD_ELEMENTS,
  SET_COMPUTEPD,
  SET_CLOSE_WINDOW_PENDING,
  SET_COMPUTEPD_PENDING,
  SET_CONSULT_PIPE,
  SET_CLEAR_PIPES_PENDING,
  SET_DELETE_PIPE_PENDING,
  SET_PLC_CURRENTFIELD,
  SET_PIPES,
  SET_CONSULTPIPES_PENDING,
  SET_PLC_FILTER_VALUES,
  CLOSE_CONSULT_PIPE_MODAL,
  SET_INLET_FIELD,
  OPEN_CONSULT_PIPE_MODAL,
  SET_PIPES_PENDING,
  SET_ADDPIPE_PENDING,
  OPEN_DELETE_PIPE_MODAL,
  CLOSE_DELETE_PIPE_MODAL,
  SET_CLOSE_WINDOW,
  SET_CLOSE_REDIRECT,
  CONSULT_PIPE_DISABLE,
  SET_OUTLET_FIELD,
  SET_COMPUTEPD_OUTLET,
  OPEN_NONNEWTONIAN_MODEL,
  CLOSE_NONNEWTONIAN_MODEL,
  SET_NONNEWTONIAN_VALUES,
  SET_ERROR_REDIRECT,
  OPEN_LIQUID_GRAPH_MODAL,
  SORT_COORDINATES_PENDING,
  CLOSE_LIQUID_GRAPH_MODAL,
  VALIDATE_GRAPH_PENDING,
  SET_IMAGINARY_LINE
} from "../constants/plc.constants";
import { plcDataState } from "../../types/plcData";

const initialState: plcDataState = {
  plcFilterValues: {},
  inletPipeSystem: {},
  diffPressurePending: false,
  isOpenDeleteModal: false,
  isCloseRedirect: true,
  plcCurrentField: "",
  elements: {
    familyAndElements: [],
    pipeMaterial: ["Drawn tubing of plastics ans similar"],
  },
  isOpenNonNewtonianModel: false,
  isErrorRedirect: false,
  isOpenGraph: false,
  isSortPending: false,
  isValidateGraphPending: false,
  nonNewtonianValues: [
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
    { shearRate: null, viscosity: null },
  ],
};

export default (
  localState: UserState = initialState,
  action: Action
): plcDataState => {
  switch (action.type) {
    case SET_ADD_ELEMENTS_PENDING: {
      return {
        ...localState,
        addElementsPending: true,
      };
    }
    case SET_ADD_ELEMENTS: {
      return {
        ...localState,
        elements: action.payload,
      };
    }
    case SET_PLC_CURRENTFIELD: {
      return {
        ...localState,
        plcCurrentField: action.payload,
      };
    }
    case SET_PLC_FILTER_VALUES: {
      return {
        ...localState,
        plcFilterValues: action.payload,
      };
    }
    case SET_INLET_FIELD: {
      return {
        ...localState,
        inletField: action.payload,
      };
    }
    case SET_ADDPIPE_PENDING: {
      return {
        ...localState,
        addPipePending: action.payload,
      };
    }
    case OPEN_DELETE_PIPE_MODAL: {
      return {
        ...localState,
        isOpenDeleteModal: true,
      };
    }
    case CLOSE_DELETE_PIPE_MODAL: {
      return {
        ...localState,
        isOpenDeleteModal: false,
      };
    }
    case SET_PIPES_PENDING: {
      return {
        ...localState,
        getPipesPending: true,
      };
    }
    case SET_PIPES: {
      return {
        ...localState,
        pipesList: action.payload,
      };
    }
    case OPEN_CONSULT_PIPE_MODAL: {
      return {
        ...localState,
        isOpenConsultPipe: true,
      };
    }
    case CLOSE_CONSULT_PIPE_MODAL: {
      return {
        ...localState,
        isOpenConsultPipe: false,
      };
    }
    case SET_CONSULTPIPES_PENDING: {
      return {
        ...localState,
        isConsultPending: true,
      };
    }
    case SET_CONSULT_PIPE: {
      return {
        ...localState,
        elements: action.payload,
      };
    }
    case SET_DELETE_PIPE_PENDING: {
      return {
        ...localState,
        isDeletePending: true,
      };
    }
    case SET_CLEAR_PIPES_PENDING: {
      return {
        ...localState,
        isClearPipesPending: action.payload,
      };
    }
    case SET_COMPUTEPD_PENDING: {
      return {
        ...localState,
        isComputePDPending: true,
      };
    }
    case SET_COMPUTEPD: {
      return {
        ...localState,
        pressureDropList: action.payload,
      };
    }
    case SET_COMPUTEPD_OUTLET: {
      return {
        ...localState,
        pressureDropListOutlet: action.payload,
      }
    }
    case SET_CLOSE_WINDOW_PENDING: {
      return {
        ...localState,
        isCloseWindowPending: true,
      };
    }
    case SET_CLOSE_WINDOW: {
      return {
        ...localState,
        plcFilterValues: action.payload,
      }
    }
    case SET_CLOSE_REDIRECT: {
      return {
        ...localState,
        isCloseRedirect: action.payload,
      }
    }
    case CONSULT_PIPE_DISABLE: {
      return {
        ...localState,
        isConsultDisable: action.payload,
      }
    }
    case SET_OUTLET_FIELD: {
      return {
        ...localState,
        outletField: action.payload,
      }
    }
    case OPEN_NONNEWTONIAN_MODEL:{
      return {
        ...localState,
        isOpenNonNewtonianModel: true
      }
    }
    case CLOSE_NONNEWTONIAN_MODEL:{
      return {
        ...localState,
        isOpenNonNewtonianModel: false,
      }
    }
    case SET_NONNEWTONIAN_VALUES: {
      return {
        ...localState,
        nonNewtonianValues: action.payload,
      }
    }
    case SET_ERROR_REDIRECT: {
      return {
        ...localState,
        isErrorRedirect: action.payload,
      }
    }
    case OPEN_LIQUID_GRAPH_MODAL: {
      return {
        ...localState,
        isOpenGraph: true,
      }
    }
    case SORT_COORDINATES_PENDING: {
      return {
        ...localState,
        isSortPending: action.payload,
      }
    }
    case CLOSE_LIQUID_GRAPH_MODAL: {
      return {
        ...localState,
        isOpenGraph: false,
      }
    }
    case VALIDATE_GRAPH_PENDING: {
      return {
        ...localState,
        isValidateGraphPending: action.payload,
      }
    }
    case SET_IMAGINARY_LINE: {
      return {
        ...localState,
        imaginaryLine: action.payload,
      }
    }
    default: {
      return localState;
    }
  }
};
